import * as React from "react";
import Mainlayout from "../components/layouts/MainLayout";
import DraftChat from "../features/draft/components/DraftChat";

export interface DraftModeProps {
  headerLeft?: React.ReactNode;
}

const DraftMode = ({ headerLeft }: DraftModeProps) => {
  return (
    <Mainlayout headerLeft={headerLeft}>
      <DraftChat />
    </Mainlayout>
  );
};

export default DraftMode;
